module.exports = __webpack_public_path__ + "static/images/styles/images/plus-icon.8c2fd9b4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/plus-icon.png
// module id = 3679
// module chunks = 11